import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useCallback,
} from "react";
import { NavLink } from "react-router-dom";
import Moment from "react-moment";
import moment from "moment";
import { useReactToPrint } from "react-to-print";

import ManageSidebar from "../ManageSidebar";

import {
  getCookie,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
  _t,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { MdDelete } from "react-icons/md";

import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";

import "react-confirm-alert/src/react-confirm-alert.css";

import { UserContext } from "../../../../../contexts/User";
import { SettingsContext } from "../../../../../contexts/Settings";
import DataTable from "../../../../common/DataTable";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";
import "../stock/stock.css";

const parseAmount = (value) => {
  const n = parseFloat(value);
  return Number.isNaN(n) || value === "" ? 0 : n;
};

const BankDropList = () => {
  const { t } = useTranslation();
  const { authUserInfo } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);

  const [bankDropList, setBankDropList] = useState(null);
  const [bankDropListForSearch, setBankDropListForSearch] = useState(null);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const [searchedList, setSearchedList] = useState({
    list: null,
    searched: false,
  });

  const searchInputRef = useRef(null);

  useEffect(() => {
    getBankDropList(1);
  }, []);

  const getBankDropList = async (pageNo) => {
    setIsFetchingData(true);
    const url = BASE_URL + "/settings/bank-drop?page=" + pageNo;

    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });




      setBankDropList(res.data[0]);
      setBankDropListForSearch(res.data[1]);
    } catch (error) {
 
    } finally {
      setIsFetchingData(false);
    }
  };

  const [printItem, setPrintItem] = useState(null);
  const printRef = useRef();
  const handleOnlyPrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: "@page { margin: 15px }",
  });

  const handleGetPrintData = async (item) => {
    const fallbackPrintItem = {
      document_identity: item.document_identity ?? "-",
      document_date: item.document_date,
      branch: item.branch ?? { name: "-" },
      bank_amount: parseAmount(item.bank_amount),
      expense_amount: parseAmount(item.expense_amount),
      trapped_amount: parseAmount(item.trapped_amount) ?? parseAmount(item.bank_amount) + parseAmount(item.expense_amount),
      remarks: item.remarks ?? "",
    };
    setPrintItem(fallbackPrintItem);

    const triggerPrint=()=>{
        setTimeout(() => {
          handleOnlyPrint();
        }, 500);
    };

    triggerPrint();

    // try {
    //   const url = BASE_URL + "/settings/bank-drop/" + item.id;
    //   const res = await axios.get(url, {
    //     headers: { Authorization: `Bearer ${getCookie()}` },
    //   });
    //   if (res?.data) {
    //     const d = res.data;
    //     setPrintItem({
    //       document_identity: d.document_identity ?? item.document_identity ?? "-",
    //       document_date: d.document_date ?? item.document_date,
    //       branch: d.branch ?? item.branch ?? { name: "-" },
    //       bank_amount: parseAmount(d.bank_amount ?? item.bank_amount),
    //       expense_amount: parseAmount(d.expense_amount ?? item.expense_amount),
    //       trapped_amount: parseAmount(d.trapped_amount ?? item.trapped_amount),
    //       remarks: d.remarks ?? item.remarks ?? "",
    //     });
    //   }
    //   triggerPrint();
    // } catch (err) {
    //   ToastError({ title: t("Could not load full details. Printing with available data.") });
    //   triggerPrint();
    // }
  };

  const handleDeleteAccount = (slug) => {
    setIsFetchingData(true);
    const url = BASE_URL + `/settings/bank-drop/${slug}`;
    return axios
      .delete(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setBankDropList(res.data[0]);
        setBankDropListForSearch(res.data[1]);
        setSearchedList({
          ...searchedList,
          list: res.data[1],
        });
        setIsFetchingData(false);
        ToastSuccess({ title: t("Bank drop has been deleted successfully") });
      })
      .catch(() => {
        setIsFetchingData(false);
        ToastError({ title: t("Please try again") });
      });
  };

  const handleSearch = (e) => {
    const searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedList({ ...searchedList, searched: false });
    } else {
      const list = bankDropListForSearch || [];
      const filtered = list.filter((item) => {
        const docNo = (item.document_identity || "").toLowerCase();
        const amount = (item.total_net_amount || item.amount || "").toString().toLowerCase();
        const date = item.document_date
          ? moment(item.document_date).format("LL").toLowerCase()
          : "";
        const customer = (item.customer?.name || "").toLowerCase();
        return (
          docNo.includes(searchInput) ||
          amount.includes(searchInput) ||
          date.includes(searchInput) ||
          customer.includes(searchInput)
        );
      });
      setSearchedList({
        ...searchedList,
        list: filtered,
        searched: true,
      });
    }
  };

  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{t("Are you sure?")}</h1>
            <p className="text-center">{t("You want to delete this?")}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteAccount(slug);
                  onClose();
                }}
              >
                {t("Yes, delete it!")}
              </button>
              <button
                className="btn btn-success ml-2 px-3 rounded"
                onClick={onClose}
              >
                {t("No")}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handlePostApi = async (item) => {
    setActionLoading(true);
    const url = BASE_URL + "/settings/bank-drop-post";
    const formData = new FormData();
    formData.append("id", item.id);
    formData.append("is_post", item.is_post ? 0 : 1);
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setBankDropList(res.data[0]);
        setBankDropListForSearch(res.data[1]);
        setSearchedList((prev) => ({ ...prev, list: res.data[1] }));
        ToastSuccess({
          title: t(
            item.is_post
              ? "Bank drop has been unpost"
              : "Bank drop has been post"
          ),
        });
      }
      setActionLoading(false);
    } catch (err) {
      setActionLoading(false);
      const message = err?.response?.data?.message ? err.response.data.message : t("Please try again");
      ToastError({ title: message });
    }
  };

  const handleUnPostConfirmation = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body px-5">
            <h3>{t("Are you sure?")}</h3>
            <p className="text-center">{t("You want to un post this?")}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handlePostApi(item);
                  onClose();
                }}
              >
                {t("Yes, unpost it!")}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {t("No")}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleFetchData = (page) => {
    getBankDropList(page);
  };

  const COLUMNS = [
    { label: "S/L", render: (item, i) => i + 1 },
    { label: "Document No", key: "document_identity" },
    {
      label: "Document Date",
      render: (item) => (
        <Moment format="LL">{item.document_date}</Moment>
      ),
    },
    { label: "Branch", render: (item) => item.branch?.name || "-" },
    {
      label: "Bank Drop Amount",
      render: (item) => parseAmount(item.bank_amount) ?? "-",
    },
    {
      label: "Expense Amount",
      render: (item) => parseAmount(item.expense_amount) ?? "-",
    },
    {
      label: "Total",
      render: (item) => parseAmount(item.trapped_amount)
      ?? "-",
    },
    {
      label: "Action",
      render: (item) => (
        <div className="d-flex justify-content-center">
          {item.is_post !== 1 && (
            <>
              <NavLink
                title="Edit"
                className="btn btn-primary ml-2 rounded-sm del-btn"
                to={`/dashboard/manage/stock/bank-drop-edit/${item.id}`}
              >
                <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
              </NavLink>
              {/* <button
                title="Delete"
                className="btn btn-danger ml-2 rounded-sm del-btn"
                onClick={() => handleDeleteConfirmation(item.id)}
              >
                <MdDelete className="del-icon" />
              </button> */}
            </>
          )}
          <button
            title="Print"
            className="btn btn-secondary ml-2 rounded-sm del-btn"
            onClick={() => handleGetPrintData(item)}
          >
            <i className="fa fa-print edit-icon"></i>
          </button>
          {item.is_post !== 1 ? (
            <button
              className="btn btn-dark ml-2 rounded-sm del-btn"
              title="Post Bank Drop"
              style={{ padding: "1px 0px 0px 1px" }}
              disabled={actionLoading}
              onClick={() => handlePostApi(item)}
            >
              <i className="fa fa-check-square-o" aria-hidden="true"></i>
            </button>
          ) : null}
        </div>
      ),
    },
  ];

  const getListData = useCallback(() => {
    if (searchedList.searched) {
      return searchedList.list;
    }
    return bankDropList?.data || [];
  }, [searchedList, bankDropList]);

  const onClearSearch = () => {
    setSearchedList({ ...searchedList, searched: false });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("Bank Drop List")}</title>
      </Helmet>

      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>

            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="">
                <div key="fragment3">
                  <div className="t-bg-white">
                    <div className="row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                      <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                        <ul className="t-list fk-breadcrumb">
                          <li className="fk-breadcrumb__list">
                            <span className="t-link fk-breadcrumb__link text-capitalize">
                              {t("Bank Drop List")}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6 col-lg-7">
                        <div className="row gx-3 align-items-center">
                          <div className="col-md-9 t-mb-15 mb-md-0">
                            <div className="input-group">
                              <div className="form-file">
                                <input
                                  type="text"
                                  className="form-control border-0 form-control--light-1 rounded-left"
                                  placeholder={t("Search") + ".."}
                                  onChange={handleSearch}
                                  disabled={isFetchingData}
                                  ref={searchInputRef}
                                />
                              </div>
                              <button
                                className="btn btn-primary rounded-right"
                                type="button"
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                          </div>
                          <div className="col-md-3 text-md-right">
                            <NavLink
                              to="/dashboard/manage/stock/bank-drop-add"
                              className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                            >
                              {t("add new")}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <DataTable
                    loading={actionLoading || isFetchingData}
                    data={getListData()}
                    columns={COLUMNS}
                    emptyText="No data available"
                    pagination={{
                      isPageLoading: actionLoading,
                      isPagination: true,
                      pageCount: bankDropList?.last_page,
                      currentPage: bankDropList?.current_page,
                      from: bankDropList?.from,
                      to: bankDropList?.to,
                      total: bankDropList?.total,
                    }}
                    handleFetchData={handleFetchData}
                    searchPayload={{
                      isSearched: searchedList.searched,
                      onClearSearch,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Print layout - header like StockReport.js */}
      <div className="d-none">
        <div ref={printRef}>
          {printItem && (
            <div className="fk-print" style={{ margin: "20px" }}>
              <div>
                <div className="row">
                  <div className="col-12">
                    <div className="mx-auto" style={{ width: "90px" }}>
                      <img
                        src={`${getSystemSettings(generalSettings, "type_logo")}`}
                        style={{ width: "100%" }}
                        alt=""
                      />
                    </div>
                    <h3 className="text-center xslg-text my-2">
                      {getSystemSettings(generalSettings, "siteName")}
                    </h3>
                    <div className="my-2 lg-text print-text-stock text-center text-capitalize print-text-stock--bold">
                      {printItem.branch?.name ?? "-"}
                    </div>
                    <div className="my-2 lg-text print-text-stock text-center text-capitalize print-text-stock--bold">
                      {_t(t("Bank Drop"))}
                    </div>
                    <div className="mt-4 my-2 print-text-stock row text-capitalize ml-0">
                      <div className="col-6 print-text-stock--bold">
                        {_t(t("Document No"))}: {printItem.document_identity}
                      </div>
                      <div className="col-6 print-text-stock--bold">
                        {_t(t("Document Date"))}:{" "}
                        {printItem.document_date ? (
                          <Moment format="LL">{printItem.document_date}</Moment>
                        ) : "-"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                    <table className="table table-bordered-sm table-hover">
                      <thead className="align-middle">
                        <tr>
                          <th
                            scope="col"
                            className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                          >
                            {_t(t("Type"))}
                          </th>
                          <th
                            scope="col"
                            className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                          >
                            {_t(t("Amount"))}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="align-middle">
                        <tr>
                          <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                            {_t(t("Bank Drop"))}
                          </td>
                          <td className="print-text-stock border-dark border-1 align-middle text-center">
                            {currencySymbolLeft()}
                            {formatPrice(printItem.bank_amount)}
                            {currencySymbolRight()}
                          </td>
                        </tr>
                        <tr>
                          <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                            {_t(t("Expense"))}
                          </td>
                          <td className="print-text-stock border-dark border-1 align-middle text-center">
                            {currencySymbolLeft()}
                            {formatPrice(printItem.expense_amount)}
                            {currencySymbolRight()}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th className="print-text-stock text-capitalize align-middle text-right border-dark border-1 border">
                            {_t(t("Total Amount"))}
                          </th>
                          <th className="print-text-stock align-middle text-center border-dark border-1 border">
                            {currencySymbolLeft()}
                            {formatPrice(printItem.trapped_amount)}
                            {currencySymbolRight()}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                    <div className="mb-4 my-2 print-text-stock text-capitalize print-text-stock--bold d-flex">
                      {_t(t("Description"))}:{" "}
                      <span className="text-preline">{printItem?.remarks}</span>
                    </div>
                </div>
              </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BankDropList;
